import React, { Component } from 'react'
import moment from 'moment'
import { StyledContent } from '../../styles/mixins'
import {Link} from 'react-router-dom'
import { StyledCard } from './style'
import apiService from '../../actions/apiService'
import { Row, Col, Spin, Card } from 'antd';
class OpenPosts extends Component {
  
  state = {
    isLoading: true,
    posts: [],
  }
  
  async componentWillMount() {
    const response = await apiService.getMethod('/OpenPosts/list');
    const stateUpdate = {isLoading: false};
    if (response) {
      stateUpdate.posts = response;
    }
    this.setState({
      ...stateUpdate,
    });
  }
  
  render() {
    const {posts, isLoading} = this.state;
    const gridStyle = {
      width: '20%',
      textAlign: 'center',
      fontSize: 12,
    };
    return (
      <StyledContent>
        <StyledCard title="Posts" bordered={false}>
          <Row gutter={16}>
            <Col sm={24} xs={24}>
              {
                isLoading && <Spin />
              }
              {
                !isLoading &&
                <Card title={null} style={{background: '#fff'}} bordered={false}>
                  {
                    posts.map((post, i) => {
                      return (
                        <Card.Grid className="sub-card" key={i} style={gridStyle}>
                          <Link
                            to={`/post-detail/${post.id}`}>
                            <h5>{post.title}</h5>
                            {post.postDate ? moment(post.postDate.substr(0, 10)).format('MMM DD, YYYY') : ''}
                          </Link>
                        </Card.Grid>
                      )
                    })
                  }
                </Card>
              }
            </Col>
          </Row>
        </StyledCard>
      </StyledContent>
    )
  }
}

export default OpenPosts



// WEBPACK FOOTER //
// ./src/components/open-posts/index.js